import antd from 'ant-design-vue/es/locale-provider/pl_PL';
import dayjsLocale from 'dayjs/locale/pl';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/pl.json';

const components = {
  antLocale: antd,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'pl',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
